@if (profissional; as prof) {
<div class="n-card-proposal">
  <!-- Top Header Row -->
  <div class="n-header-row flex align-items-center justify-content-between gap-2">
    <!-- Avatar + Profissional Info -->
    <div class="flex align-items-center gap-3 min-w-0 flex-1">
      @if (getImagemPerfilUrl(prof); as imagemUrl) {
        <img class="n-avatar-squircle object-cover flex-shrink-0" [src]="imagemUrl" [alt]="prof.nome" />
      } @else {
        <div class="n-avatar-squircle flex align-items-center justify-content-center flex-shrink-0" [style.background-color]="getAvatarColor(prof.id)">
          {{ getIniciais(prof.nome) }}
        </div>
      }
      <div class="flex flex-column min-w-0">
        <h3 class="n-cliente-nome m-0 text-overflow-ellipsis overflow-hidden white-space-nowrap" [title]="prof.nome">
          {{ prof.nome }}
        </h3>
        
        <div class="flex flex-wrap align-items-center gap-2 mt-1">
          @if (prof.descricao) {
            <span class="n-cliente-status text-xs text-overflow-ellipsis overflow-hidden white-space-nowrap max-w-12rem">
              {{ prof.descricao }}
            </span>
          }
          <div class="flex align-items-center gap-1 text-xs">
            <span class="n-horario-text text-500 font-medium">
              {{ formatarHorario(prof.inicioExpediente) }} - {{ formatarHorario(prof.fimExpediente) }}
            </span>
            <span
              class="n-badge-pill text-xs font-semibold px-2 py-1 border-round-lg"
              [class.ativa]="!prof.ferias"
              [class.ferias]="prof.ferias"
            >
              {{ prof.ferias ? ('BARDO_PROFISSIONAIS.FERIAS' | translate) : ('BARDO_PROFISSIONAIS.ATIVA' | translate) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Button Pill -->
    @if (possuiPermissao('Bardo.profissionais.delete')) {
      <button
        type="button"
        class="n-btn-excluir flex align-items-center gap-1 cursor-pointer border-none flex-shrink-0"
        (click)="confirmarExclusao(prof, $event)"
        [title]="'GLOBAL.EXCLUIR' | translate"
      >
        <i class="pi pi-trash text-xs"></i>
        <span>{{ 'GLOBAL.EXCLUIR' | translate }}</span>
      </button>
    }
  </div>

  <!-- Stat Cards Row (Strictly 3 columns on Mobile & Desktop) -->
  <div class="n-metricas-grid mt-4">
    @if (carregandoMetricas()) {
      <div class="n-metricas-loading">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
    } @else {
      <!-- CANCELADOS -->
      <div class="n-stat-card cancelados">
        <span class="n-stat-label">{{ 'BARDO_PROFISSIONAIS.METRICAS.CANC' | translate }}</span>
        <span class="n-stat-value text-red">{{ formatarZeroEsquerda(metricas.cancelados) }}</span>
      </div>

      <!-- ATENDIDOS -->
      <div class="n-stat-card atendidos highlighted">
        <span class="n-stat-label text-purple">{{ 'BARDO_PROFISSIONAIS.METRICAS.ATEND' | translate }}</span>
        <span class="n-stat-value text-purple">{{ formatarZeroEsquerda(metricas.atendidos) }}</span>
      </div>

      <!-- CONFIRMADOS -->
      <div class="n-stat-card confirmados">
        <span class="n-stat-label">{{ 'BARDO_PROFISSIONAIS.METRICAS.CONF' | translate }}</span>
        <span class="n-stat-value text-green">{{ formatarZeroEsquerda(metricas.confirmados) }}</span>
      </div>
    }
  </div>

  <!-- Services Section -->
  <div class="n-servicos-section mt-4">
    <div class="n-section-title-container flex align-items-center gap-2 mb-3">
      <span class="n-section-title text-xs font-bold uppercase tracking-wider">{{ 'BARDO_PROFISSIONAIS.SERVICOS_VINCULADOS' | translate | uppercase }}</span>
      <div class="n-title-line flex-1"></div>
    </div>

    @if (servicosDetalhados().length > 0) {
      <div class="n-servicos-list flex flex-column gap-2">
        @for (servico of servicosLista(); track servico.idRelacionamento; let idx = $index) {
          <div class="n-servico-pill-item flex align-items-center justify-content-between p-3">
            <div class="flex align-items-center gap-2 min-w-0">
              <span class="n-servico-dot flex-shrink-0" [class.highlight]="idx === 0"></span>
              <span class="n-servico-name font-semibold text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap">
                {{ servico.nome }}
              </span>
            </div>
            <span class="n-servico-badge text-xs font-semibold flex-shrink-0 ml-2">
              {{ servico.categoria }}
            </span>
          </div>
        }
      </div>

      <!-- Bottom Footer Button -->
      @if (hasMaisServicos()) {
        <div class="n-footer-action mt-4 pt-2">
          <button
            type="button"
            class="n-btn-historico w-full py-3 px-4 font-bold text-sm cursor-pointer"
            (click)="toggleExibirTodosServicos()"
          >
            {{ exibirTodosServicos() ? ('BARDO_PROFISSIONAIS.RECOLHER_SERVICOS' | translate: { termo: $nicho().servico.plural.toLowerCase() }) : ('BARDO_PROFISSIONAIS.VER_TODOS_SERVICOS' | translate: { termo: $nicho().servico.plural.toLowerCase() }) }}
          </button>
        </div>
      }
    } @else {
      <div class="n-empty-servicos text-center py-3 text-500 text-sm border-round-lg">
        {{ 'BARDO_PROFISSIONAIS.NENHUM_SERVICO_VINCULADO' | translate: { termo: $nicho().servico.singular.toLowerCase(), profissional: $nicho().profissional.singular.toLowerCase() } }}
      </div>
    }
  </div>
</div>
}

<!-- Mobile Bottom Sheet para Confirmar Exclusão de Profissional -->
@if (deviceService.$isMobile() && modalExclusaoAberto()) {
<lib-bottom-sheet
  [visible]="modalExclusaoAberto()"
  (visibleChange)="modalExclusaoAberto.set($event)"
  size="medium"
  [draggable]="true"
  [closeOnBackdrop]="!excluindo()"
  [closeOnEscape]="!excluindo()"
  [preventClose]="excluindo()"
  [headerTemplate]="headerExcluirTemplate"
  [footerTemplate]="footerExcluirTemplate"
  (hide)="modalExclusaoAberto.set(false)"
>
  <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
    <div class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>
    <p class="m-0 text-700 text-base line-height-3" [innerHTML]="'BARDO_PROFISSIONAIS.CONFIRMAR_EXCLUSAO_MSG' | translate: { termo: $nicho().profissional.singular.toLowerCase(), nome: profissional?.nome }">
    </p>
  </div>
</lib-bottom-sheet>
}

<ng-template #headerExcluirTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'GLOBAL.CONFIRMAR_EXCLUSAO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerExcluirTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalExclusaoAberto.set(false)"
      [disabled]="excluindo()"
    />
    <p-button
      [label]="'GLOBAL.SIM_EXCLUIR' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="excluindo()"
      (onClick)="excluirProfissional(profissional?.id)"
    />
  </div>
</ng-template>

